import { createContext, useContext } from 'react';

import { AspirationsToday, Equipment, Site } from '@/types.gql';

const AspirationContext = createContext<{
  aspDate: Date;
  setAspDate: (date: Date) => void;
  aspSite: Site | null;
  setAspSite: (site: Site) => void;
  opuTech: Equipment | null;
  setOpuTech: (tech: Equipment) => void;
  quickSearchValue: string;
  setQuickSearchValue: (string: string) => void;
  selectedAspiration: AspirationsToday | null;
  setSelectedAspiration: (aspiration: AspirationsToday) => void;
  aspirations: AspirationsToday[] | undefined;
  refetchTodaysAspirations: () => void;
  qcDataSubmitted: boolean;
  setQcDataSubmitted: (submitted: boolean) => void;
} | null>(null);

export function useAspirationContext() {
  const context = useContext(AspirationContext);

  if (!context) {
    throw new Error(
      'Aspiration.* component must be rendered as child of Aspiration component',
    );
  }

  return context;
}

export default AspirationContext;
